import { Component, Inject, PLATFORM_ID, OnInit } from "@angular/core";
import { NavigationEnd, Router, ActivatedRoute } from "@angular/router";
import { MessagingService } from "./services/messaging.service";
import { DataSharingService } from "./services/data.share.service";
import { I18nService } from "./services/i18n.service";
import { isPlatformBrowser } from "@angular/common";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { LocaleService } from "./services/locale.service";
import { VersionService } from "./version.service";

declare var dataLayer: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "buki";
  message: any;
  isNew: any;

  constructor(
    private localeService: LocaleService,
    @Inject(PLATFORM_ID) private platformId: any,
    private router: Router,
    private api: AdminService,
    private dataSharingService: DataSharingService,
    private messagingService: MessagingService,
    private languge: I18nService,
    private active: ActivatedRoute,
    private version: VersionService
  ) {
    // Tracking page_view
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd && typeof dataLayer !== "undefined") {
          dataLayer.push({
            event: "page_view",
            page_path: evt.urlAfterRedirects,
            page_location: window.location.href,
            page_title: document.title,
          });
        }
      });

      // Observador de cambio de idioma automático
      const observer = new MutationObserver(() => {
        if (document.documentElement.className.match("translated")) {
          observer.disconnect(); // Detener la observación para evitar bucle infinito
        }
      });

      observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.version.init(120000);
      this.version.checkNow();
      console.log("versión nueva!!");
    }
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    this.dataSharingService.currentLanguage.subscribe((language) => {
      this.languge.fetch(language);
    });

    const languages: any = localStorage.getItem("language");
    const languageSet = languages == 1 ? "sp" : languages == 2 ? "en" : "pt";
    const languageCode = languages == 1 ? "es" : "en";
    document.documentElement.setAttribute("lang", languageCode);

    this.localeService.initLocale(languageCode);
    this.languge.fetch(languageSet);
  }

  languageChange(value: any) {
    const data = { language: Number(value) };
    this.api.putData(apiUrl._updateProfile, data).subscribe(() => {
      const languageSet = value == 1 ? "sp" : value == 2 ? "en" : "pt";
      const languageCode = value == 1 ? "es" : "en";
      localStorage.setItem("language", languageSet);
      const lang: any =
        this.localeService.currentLocale.startsWith(languageCode);
      this.localeService.setLocale(lang);
    });
  }
}
